import React from 'react';
import PropTypes from 'prop-types';
import { Spacer, Visible } from '@tfecom-thermofisher/react-komodo-design';

import { DataSelector, SectionTitle, Remainders } from 'src/components';
import { PLATE_POOLING, PLATE_POOLING_OPTIONS } from 'src/constants/forms';

import messages from './messages';
import {
  PooledPlatesOrdering,
  PlatePoolingCustom,
  PooledPlateFields,
} from './components';

import './PlatePooling.style.scss';

const PlatePoolingComponent = ({
  formData = {},
  onChangeData,
  platePoolingConfig,
  platesForPooling,
}) => {
  const showPlatePooling =
    formData[PLATE_POOLING]?.value &&
    formData[PLATE_POOLING].value !== PLATE_POOLING_OPTIONS.NONE;
  const showPooledPlates =
    formData[PLATE_POOLING]?.value &&
    (formData[PLATE_POOLING].value === PLATE_POOLING_OPTIONS.HALVES ||
      formData[PLATE_POOLING].value === PLATE_POOLING_OPTIONS.ODD_EVEN);
  const showPlatePoolingCustom = !!(
    formData[PLATE_POOLING]?.value &&
    formData[PLATE_POOLING].value === PLATE_POOLING_OPTIONS.CUSTOM
  );

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="plate-pooling-container">
        <SectionTitle title={messages.platePoolingSubTitle} allFieldsRequired />
        <Spacer bottom={24} />
        <DataSelector
          {...{
            title: messages.platePoolingSubTitle,
            config: platePoolingConfig,
            selectedValue: formData[PLATE_POOLING]?.value,
            onSelect: (value) => onChangeData(value, PLATE_POOLING, true),
          }}
        />

        <Visible when={showPlatePooling}>
          <PooledPlateFields
            {...{ formData, onChangeData, showPlatePoolingCustom }}
          />

          <Visible when={showPooledPlates}>
            <PooledPlatesOrdering
              plates={platesForPooling}
              platePooling={formData[PLATE_POOLING]?.value}
              onChangeData={onChangeData}
              formData={formData}
            />
          </Visible>

          <Visible when={!!showPlatePoolingCustom}>
            <PlatePoolingCustom {...{ formData, onChangeData }} />
          </Visible>
        </Visible>
      </div>
      <Spacer bottom={24} />

      <Visible when={showPlatePooling}>
        <Remainders />
      </Visible>
    </div>
  );
};

PlatePoolingComponent.propTypes = {
  formData: PropTypes.object,
  onChangeData: PropTypes.func.isRequired,
  platePoolingConfig: PropTypes.array.isRequired,
  platesForPooling: PropTypes.array.isRequired,
};

export default PlatePoolingComponent;
